import styled from "styled-components"
import { TABLET_MAX_WIDTH, MOBILE_MIN_WIDTH } from "@constants"

export const StyledArticleWrapper = styled.div`
  margin: 9rem 2.5rem;
  display: grid;
  grid-template-columns: 1fr 4fr;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    grid-template-columns: 1fr;
    margin: 7.26rem 0.5rem;
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    margin: 5.26rem 0;
  }
`

export const StyledArticleSidebarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 500px;
  position: sticky;
  top: 9rem;
  overflow-x: hidden !important;
  overflow-y: auto !important;
`

export const StyledMainContentWrapper = styled.div`
  max-width: 45.75rem;
  padding: 0 30px;
  margin: 0 40px;

  & img {
    width: 100%;
  }

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    max-width: 90vw;
  }

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
    padding: 0;
    margin: 0 18px;
  }
`

export const StyledMainArticleContent = styled.div`
  a {
    color: #C8991F;
    text-decoration: none;
  }

  h2 {
    color: #252525;
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 2.25rem;
    letter-spacing: 0.56px;
  }
  h3 {
    font-size: 1.438rem;
  }
  h4 {
    font-size: calc(19px + 2 * (100vw / 1440));
  }
  p {
    font-size: calc(19px + 2 * (100vw / 1440));
    line-height: 160%;
    letter-spacing: 0.4px;
    color: #252525;
    font-weight: 400;

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
      letter-spacing: 0.8px;
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
    list-style: none;

    li {
      color: #252525;
      font-size: calc(19px + 1 * (100vw / 1440));
      line-height: 30px;
      letter-spacing: 0.54px;
      font-weight: 400;

      &::before {
        background: #86723e;
        content: "";
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 2px;
        height: 6px;
        width: 6px;
      }

      @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
        line-height: 24px;
        letter-spacing: 0.8px;
      }
    }

    @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
      padding: 8px;
    }
  }

  ol {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
    color: #252525;

    li {
      font-size: calc(19px + 1 * (100vw / 1440));
      line-height: 30px;
      letter-spacing: 0.4px;
      font-weight: 400;

      @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
        line-height: 24px;
        letter-spacing: 0.8px;
      }
    }
  }

  figure {
    margin: 0;
    padding: 0;
    width: 100%;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    table {
      border-collapse: collapse;
      text-align: center;
      width: 100%;

      thead {
        background: rgba(196, 177, 128, 0.1);
        tr th {
          color: #252525;
          text-align: center;
        }
      }

      td p {
        font-size: 17px;
        width: fit-content;
      }

      td,
      th {
        border: 1px solid #c4b180;
        padding: 8px;
        font-size: calc(17px + 1 * (100vw / 1440 ));
      }

      th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: center;
        color: #252525;
      }
    }
  }

  iframe {
    width: 100%;
  }

  blockquote {
    margin: 0;
    p {
      color: black;
      font-size: 24px;
      font-weight: 400;
      letter-spacing: 0.48px;
      display: flex;
      gap: 15px;

      &::before {
        content: url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M14.2771%2014.8339V24H5V17.9557C5%2015.6531%205.39759%2013.572%206.19277%2011.7122C6.98795%209.80812%208.33534%207.90406%2010.2349%206L13.6145%208.65682C12.5542%209.80812%2011.7369%2010.8708%2011.1627%2011.845C10.5884%2012.8192%2010.2129%2013.8155%2010.0361%2014.8339H14.2771ZM27%2014.8339V24H17.7229V17.9557C17.7229%2015.6531%2018.1205%2013.572%2018.9157%2011.7122C19.7108%209.80812%2021.0582%207.90406%2022.9578%206L26.3374%208.65682C25.2771%209.80812%2024.4598%2010.8708%2023.8855%2011.845C23.3112%2012.8192%2022.9357%2013.8155%2022.759%2014.8339H27Z%22%20fill%3D%22%23C4B180%22%2F%3E%0A%3C%2Fsvg%3E);
      }

      @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
        font-size: 20px;
      }
    }
  }
`
